export const AUTHORS_ITEM = {
    editAuthor: 'Перейти в редактирование автора',
    isFired: '(уволен/а)'
}